export default __webpack_public_path__ + "static/media/Ficho-amarillo.d84b19ab.png";